import { createStyles, useTheme, withStyles } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';
import { Transition } from 'react-transition-group';
import { ENTERED, ENTERING, EXITED, EXITING, UNMOUNTED } from 'react-transition-group/Transition';
import { APPLICATION_DRAWER_WIDTH } from '../../../../../const/settings';
import { getClassName } from '../../../../../utils/styles';
import AppDrawerComplexList from './AppDrawerComplexList';
import {
  DASHBOARD_BOX_SHADOW,
  DASHBOARD_BOX_SHADOW_DARK,
  NAVBAR_COLOR,
} from '../../../../../const/color-const';

const parseStyleFromState = (state) => {
  switch (state) {
    case ENTERED:
    case ENTERING:
      return 'rootEntering';
    case EXITED:
    case EXITING:
    case UNMOUNTED:
    default:
      return 'rootExiting';
  }
};

const styles = createStyles(theme => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    boxShadow: theme.palette.type === 'light' ? 'unset' : 'rgb(0 0 0 / 12%) 0px 0px 8px 2px',
    transition: theme.transitions.create(
      'width',
      { duration: theme.transitions.duration.standard },
    ),
  },
  rootEntering: {
    width: APPLICATION_DRAWER_WIDTH,
    transition: theme.transitions.create(
      'width',
      { duration: theme.transitions.duration.enteringScreen },
    ),
  },
  rootExiting: {
    width: 0,
    transition: theme.transitions.create(
      'width',
      { duration: theme.transitions.duration.leavingScreen },
    ),
  },
  content: {
    color: NAVBAR_COLOR,
    width: APPLICATION_DRAWER_WIDTH,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflowX: 'hidden',
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch',
    boxShadow: theme.palette.type === 'light' ? DASHBOARD_BOX_SHADOW : DASHBOARD_BOX_SHADOW_DARK,
  },
  contentSpacer: {
    ...theme.mixins.toolbar,
  },
}));

const AppDrawerComplexColumn = React.forwardRef((props, ref) => {
  const { classes, dark, modal, menuDefinition, submenuOpened, onClick, onSubmenuClick } = props;
  
  const [currentMenuDefinition, setCurrentMenuDefinition] = React.useState(menuDefinition);
  const [incomingMenuDefinition, setIncomingMenuDefinition] = React.useState(menuDefinition);
  
  React.useEffect(() => {
    if (currentMenuDefinition === null && incomingMenuDefinition === null) {
      // set current menu definition
      setIncomingMenuDefinition(menuDefinition);
      setCurrentMenuDefinition(menuDefinition);
    } else {
      // change current menu definition
      setIncomingMenuDefinition(menuDefinition);
      // setCurrentMenuDefinition will be invoked on current menu closure
    }
  }, [menuDefinition, currentMenuDefinition, incomingMenuDefinition]);
  
  const theme = useTheme();
  
  return (
    <Transition
      in={Boolean(currentMenuDefinition && currentMenuDefinition === incomingMenuDefinition)}
      timeout={{
        appear: theme.transitions.duration.standard,
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen,
      }}
      onExited={() => {
        setCurrentMenuDefinition(incomingMenuDefinition);
      }}>
      {state => (
        <div className={classNames(classes.root, dark && classes.rootDark,
          getClassName(classes, parseStyleFromState(state)),
        )}>
        
          {!modal && (
            <div className={classes.contentSpacer} />
          )}
        
          <div className={classes.content}>
            {currentMenuDefinition && (
              <AppDrawerComplexList
                menuDefinition={currentMenuDefinition}
                submenuOpened={submenuOpened}
                onClick={onClick}
                onSubmenuClick={onSubmenuClick}
              />
            )}
          </div>
        </div>
      )}
    </Transition>
  );
});

export default withStyles(styles, { name: 'AppDrawerComplexColumn' })(AppDrawerComplexColumn);
